import { SecuredKoppClient } from "Core/Api/Kopp/SecuredKoppClient";
import CargoChargesResultModel from "../CargoChargesResultsModel";
import { UpsertToCartCommandRequest, RemoveFromCartCommandRequest } from "Core/Api/Kopp/Api";

export class CargoChargeItemHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  UpsertToCart(cartItem: CargoChargesResultModel) {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = false;
    let request = new UpsertToCartCommandRequest();
    request.itemReference = cartItem.bolNumber;
    request.pickupDate = cartItem.storageDueDate?.toISOString(true);
    request.additionalInfo = JSON.stringify(cartItem.charges);
    request.cost = cartItem.total;
    return client.upsertToCart(request);
  }

  RemoveFromCart(cartItem: CargoChargesResultModel) {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = false;
    let request = new RemoveFromCartCommandRequest();
    request.itemReference = cartItem.bolNumber;
    return client.removeFromCart(request);
  }
}
